import client from '../../../../common/client';

export const CREATE_SESSION = 'CREATE_SESSION';
export const GET_MOVEMENT_SPECIALIST_PROFILES = 'GET_MOVEMENT_SPECIALIST_PROFILES';
export const GET_MOVEMENT_SPECIALIST_PROFILES_RESET = 'GET_MOVEMENT_SPECIALIST_PROFILES_RESET';
export const SET_ACTIVE_MOVEMENT_SPECIALIST_ID = 'SET_ACTIVE_MOVEMENT_SPECIALIST_ID';
export const SET_USER_LOCATION = 'SET_USER_LOCATION';
export const SET_USER_LOCATION_LOADING = 'SET_USER_LOCATION_LOADING';
export const SET_USER_VIEWED_MS_INTRODUCTION = 'SET_USER_VIEWED_MS_INTRODUCTION';

export const createSession = (userId, values) => ({
  promise: client.post(`sessions/movement-specialist-follow-up`, values),
  type: CREATE_SESSION,
});

export const getMovementSpecialistProfiles = query => ({
  promise: client.get('users/movement-specialist-profiles', query),
  type: GET_MOVEMENT_SPECIALIST_PROFILES,
});

export const resetMovementSpecialistProfiles = () => ({
  type: GET_MOVEMENT_SPECIALIST_PROFILES_RESET,
});

export const setActiveMovementSpecialistId = id => ({
  type: SET_ACTIVE_MOVEMENT_SPECIALIST_ID,
  id,
});

export const setUserLocation = (location, error) => ({
  type: SET_USER_LOCATION,
  error,
  location,
});

export const setUserLocationLoading = value => ({
  type: SET_USER_LOCATION_LOADING,
  value,
});

export const setUserViewedMsIntroduction = userId => ({
  type: SET_USER_VIEWED_MS_INTRODUCTION,
  promise: client.put(`users/${userId}/viewed-movement-specialist-introduction`),
});

export const getUserLocation = () => {
  return dispatch => {
    dispatch(setUserLocationLoading(true));

    navigator.geolocation.getCurrentPosition(
      location => {
        dispatch(setUserLocation(location.coords));
      },
      error => {
        dispatch(setUserLocation(null, error));
      },
      {
        timeout: 5000,
        maximumAge: 60000,
        fallbackToIP: true,
      }
    );
  };
};



// WEBPACK FOOTER //
// ./src/subscription/coaching/movement-specialists/redux/actions.js